import { useState } from "react";
import Loader from "react-loader-spinner";
import { toast } from "react-toastify";
import { UserX } from "lucide-react";
import httpClient from "../../custom-hooks/httpClient";
import Select from "react-select";
import Modal from "../Modal";
import { useSelector } from "react-redux";

function More() {
  // const [account, setAccount] = useState("");
  const [reason, setReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTextarea, setShowTextarea] = useState(false);
  const [otherReason, setOtherReason] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const user = useSelector((state) => state.user.user);

  const handleReasonChange = (selectedOption) => {
    if (selectedOption.value === "Other Reasons") {
      setShowTextarea(true);
    } else {
      setShowTextarea(false);
    }
    setReason(selectedOption.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    setShowModal(false);
    setIsSubmitting(true);

    try {
      const response = await httpClient.post(`/users/${user.id}/request-account-closure`, {
        reason: reason === "Other Reasons" ? otherReason : reason,
      });
      toast.success(response.data.message);
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Error submitting request! Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOtherReasonChange = (e) => {
    setOtherReason(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const reasonOptions = [
    { value: "Security and privacy concerns", label: "Security and privacy concerns" },
    { value: "Dissatisfaction with services", label: "Dissatisfaction with services" },
    { value: "Account closure or inactivity", label: "Account closure or inactivity" },
    { value: "Personal financial situation changes", label: "Personal financial situation changes" },
    { value: "Switching to a different fintech app", label: "Switching to a different fintech app" },
    { value: "Technical issues or errors", label: "Technical issues or errors" },
    { value: "Change in personal preferences", label: "Change in personal preferences" },
    { value: "Account compromise or fraud", label: "Account compromise or fraud" },
    { value: "Legal or regulatory requirements", label: "Legal or regulatory requirements" },
    { value: "Personal data management", label: "Personal data management" },
    { value: "Other Reasons", label: "Other Reasons" },
  ];

  return (
    <div className="col-12 col-md-9">
      <div className="card card-bleed shadow-light-lg mb-6">
        <div className="card-header">
          <h2 className="mb-0 text-danger fw-bold text-center mb-6">
            Delete Account
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12 col-md-6 mb-3">
                <label className="form-label" htmlFor="phone_no">
                  Phone Number
                </label>
                <input
                  className="form-control form-control-sm"
                  id="phone_no"
                  type="number"
                  defaultValue={user.phone_number}
                  readOnly
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label" htmlFor="reason">
                  Reason for Delete
                </label>
                <Select
                  id="reason"
                  options={reasonOptions}
                  onChange={handleReasonChange}
                  value={reasonOptions.find(option => option.value === reason)}
                />
                {showTextarea && (
                  <textarea
                    className="form-control mt-3"
                    rows="3"
                    value={otherReason}
                    onChange={handleOtherReasonChange}
                    placeholder="Please provide your reason"
                  />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-6">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                    onChange={handleCheckboxChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    <p>
                      {" "}
                      I hereby agree that this request will be treated according
                      to the data retention guideline, as contained in our{" "}
                      <a
                        href="/terms-and-conditions/account#account-closure"
                        className="text-decoration-none"
                      >
                        privacy policy.
                      </a>
                    </p>
                  </label>
                </div>
              </div>
            </div>
            {isSubmitting ? (
              <button
                className="btn w-100 btn-primary my-6 lift"
                type="button"
                disabled
              >
                <Loader type="Oval" color="#fff" width={20} height={20} />
              </button>
            ) : (
              <button
                className="btn w-100 btn-primary my-6 lift"
                type="submit"
                disabled={!reason || !isChecked}
              >
                Submit
              </button>
            )}
          </form>
        </div>
      </div>

      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        clickOut={true}
        closeOnEscape={true}
        noPadding
        maxWidth={400}
      >
        <div className="modal-header bg-danger border-0 flex-column align-items-center justify-content-center p-4">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 48,
              height: 48,
              background: "rgba(255,255,255,0.15)",
            }}
          >
            <UserX size={22} color="#fff" />
          </div>
          <h2
            className="text-white mb-0"
            id="modalExampleTitle"
            style={{ fontSize: "0.95rem", fontWeight: 600 }}
          >
            Delete Account
          </h2>
        </div>

        <div className="modal-body text-center px-4 py-4">
          <p
            className="mb-1"
            style={{ fontSize: "0.9rem", fontWeight: 600, color: "#0d1b12" }}
          >
            This action cannot be undone.
          </p>
          <p className="text-secondary small mb-0" style={{ lineHeight: 1.6 }}>
            Are you sure you want to proceed?
          </p>
        </div>

        <div className="modal-footer border-0 px-4 pb-4 pt-0 gap-2">
          <button
            type="button"
            className="btn btn-sm btn-light flex-fill"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger flex-fill"
            onClick={handleConfirmDelete}
          >
            Yes, Delete
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default More;
